import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import defaultAvatar from "assets/images/default-avatar.png";
import { ReactComponent as IconChevronDown } from "assets/images/icons/chevron-down.svg";
import { ReactComponent as IconLogout } from "assets/images/icons/log-out-sharp.svg";
import { ReactComponent as IconUser } from "assets/images/icons/user.svg";
import { ReactComponent as IconNotification } from "assets/images/icons/notifications-sharp.svg";
import { ReactComponent as IconStar } from "assets/images/icons/star.svg";
import { ReactComponent as IconPin } from "assets/images/icons/pin.svg";
import { ReactComponent as GroupsIcon } from "assets/images/icons/groups.svg";
import "layout/UserMenu/UserMenu.scss";
import { useAccount } from "context/AccountContext";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";

function UserMenu() {
  const { profile, checkingAuthentication } = useAccount();
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
  };

  useEffect(() => {
    const handleEscape = event => {
      if (event.code === "Escape") {
        setActive(false);
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  if (checkingAuthentication) {
    return null;
  }

  return (
    <>
      <div className={ 'user-menu' } onClick={ handleToggle }>
        <div className={ 'user-menu__avatar' }>
          { profile?.field_profile_photo?.value ?
            <ResponsiveImage value={ profile?.field_profile_photo?.value }/>
            :
            <img src={ defaultAvatar } alt={ 'Profielfoto' } className={ 'user-menu__avatar' }/>
          }
        </div>
        <div className={ `user-menu__icon ${ isActive ? 'rotate180' : '' } ` }>
          <IconChevronDown/>
        </div>

        <ul className={ `user-menu__items ${ isActive && "user-menu__items--show" }` }>
          <li className={ 'user-menu__item' }>
            <NavLink to={ '/mijn-profiel' } activeClassName={ 'active' }>
              <IconUser/>
              Mijn profiel
            </NavLink>
          </li>

          <li className={ 'user-menu__item' }>
            <NavLink to={ '/leden/favorieten' } activeClassName={ 'active' }>
              <IconStar/>
              Mijn favorieten
            </NavLink>
          </li>

          <li className={ 'user-menu__item' }>
            <NavLink to={ '/prikbord/mijn-prikbord' } activeClassName={ 'active' }>
              <IconPin/>
              Mijn prikbord
            </NavLink>
          </li>

          <li className={ 'user-menu__item' }>
            <NavLink to={ '/groepen/mijn-groepen' } activeClassName={ 'active' }>
              <GroupsIcon/>
              Mijn groepen
            </NavLink>
          </li>

          <li className={ 'user-menu__item' }>
            <NavLink to={ '/mijn-meldingen' } activeClassName={ 'active' }>
              <IconNotification/>
              Mijn meldingen
            </NavLink>
          </li>

          <li className={ 'user-menu__item' }>
            <NavLink to={ '/logout' } activeClassName={ 'active' }>
              <IconLogout/>
              Uitloggen
            </NavLink>
          </li>
        </ul>
      </div>
      <div className={ `user-menu-mask ${ isActive && "user-menu-mask--show" }` } onClick={ handleToggle }></div>
    </>
  );
}

export default UserMenu;
